import React, { useState, useEffect, useCallback } from 'react';
import { ToolbarItemController } from './toolbarItemInterface';
import { ToolbarItemViewProps } from './toolbarItemProps';
import { MdOutlineAddComment } from 'react-icons/md';
import { BiCommentAdd, BiCommentEdit } from 'react-icons/bi';
import { ReportingControllerBaseConfig } from '../../../base';

export function createToolbarItemController(
    config: ReportingControllerBaseConfig
): ToolbarItemController {
    const {
        kernel: {
            provider: { createFormController },
        },
    } = config;
    const formController = createFormController();
    return {
        useProps(context, props): ToolbarItemViewProps {
            const form = formController.useProps(props.form);
            const isSubmittable = props.values.ask.trim().length > 0;
            return {
                ask: {
                    isSubmitting: form.form.formState.isSubmitting,
                    isSubmittable,
                    form,
                    input: {
                        ...form.form.register('ask'),
                        placeholder: 'Ask AI',
                    },
                    currentThread: {
                        ...form.form.register('currentThread'),
                    },
                    button: {
                        isDisabled: !isSubmittable,
                        ...form.getSubmitButtonProps(),
                    },
                },
                menu: [
                    {
                        id: 'suggest-change',
                        description: 'Suggest change',
                        Icon: BiCommentEdit,
                        button: {
                            onClick() {
                                console.log('Bold');
                            },
                        },
                    },
                    {
                        id: 'add-comment',
                        description: 'Add a comment',
                        Icon: BiCommentAdd,
                        button: {
                            onClick() {
                                console.log('Bold');
                            },
                        },
                    },
                ],
            };
        },
    };
}
